export default function SkeletonUserPage() {
  return (
    <div className="w-full animate-pulse">
      {/* Breadcrumb */}
      <div className="flex items-center gap-[5px] my-[10px]">
        <div className="w-[17px] h-[17px] bg-gray-300 rounded" />
        <div className="w-[70px] h-[16px] bg-gray-300 rounded" />
        <div className="w-[17px] h-[17px] bg-gray-300 rounded" />
        <div className="w-[100px] h-[16px] bg-gray-300 rounded" />
      </div>

      {/* Header Section */}
      <div className="h-[145px] bg-[#0055A6] w-full py-[20px] pl-[10px] pr-[40px] flex justify-between">
        <div className="flex gap-[20px]">
          <div className="h-[94px] w-[94px] rounded-[20px] bg-gray-400" />
          <div className="h-full flex justify-around flex-col">
            <div className="w-[60px] h-[14px] bg-gray-300 rounded" />
            <div className="flex items-center gap-[10px]">
              <div className="w-[120px] h-[16px] bg-gray-300 rounded" />
              <div className="flex items-center gap-[5px]">
                <div className="w-[17px] h-[17px] bg-green-500 rounded-full" />
                <div className="w-[60px] h-[14px] bg-gray-300 rounded" />
              </div>
            </div>
            <div className="flex items-start gap-[10px]">
              <div className="w-[140px] h-[14px] bg-gray-500 rounded" />
              <div className="w-[140px] h-[14px] bg-gray-500 rounded" />
              <div className="w-[140px] h-[14px] bg-gray-500 rounded" />
            </div>
            <div className="flex items-start gap-[10px]">
              <div className="w-[140px] h-[14px] bg-white rounded" />
              <div className="w-[140px] h-[14px] bg-white rounded" />
              <div className="w-[140px] h-[14px] bg-white rounded" />
            </div>
          </div>
        </div>
        <div className="flex items-center gap-[20px]">
          <div className="w-[44px] h-[40px] bg-white rounded-[5px]" />
          <div className="w-[130px] h-[40px] bg-white rounded-[30px]" />
        </div>
      </div>

      {/* Content Section */}
      <div className="pr-[40px] pl-[10px] w-full flex gap-[2%] my-[20px]">
        {/* Left Card */}
        <div className="h-[600px] p-[20px] w-[49%] bg-white rounded-[10px] border border-[#A8A8A8]">
          <div className="w-[200px] h-[20px] bg-gray-300 rounded mb-6" />
          {[...Array(8)].map((_, i) => (
            <div
              key={i}
              className="h-[30px] my-[30px] flex items-center justify-between border-b border-[#A8A8A8]"
            >
              <div className="w-[200px] h-[16px] bg-gray-300 rounded" />
              <div className="w-[80px] h-[16px] bg-gray-300 rounded" />
            </div>
          ))}
        </div>

        {/* Right Card */}
        <div className="h-[465px] p-[20px] w-[49%] bg-white rounded-[10px] border border-[#A8A8A8]">
          <div className="w-[150px] h-[20px] bg-gray-300 rounded mb-6" />
          {[...Array(4)].map((_, i) => (
            <div
              key={i}
              className="h-[70px] my-[25px] flex items-center justify-between border-[0.7px] border-[#000000] rounded-[5px]"
            >
              <div className="w-[10%] h-full flex items-center justify-center">
                <div className="w-[24px] h-[24px] bg-gray-300 rounded" />
              </div>
              <div className="w-[85%] h-full flex flex-col justify-center gap-[6px]">
                <div className="w-[180px] h-[14px] bg-gray-300 rounded" />
                <div className="w-[220px] h-[12px] bg-gray-200 rounded" />
              </div>
              <div className="w-[5%] h-full flex items-center justify-center">
                <div className="w-[20px] h-[20px] bg-gray-300 rounded" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
